import type { UI } from '@/v2/types';
import React from 'react';
import { Flex } from '@qga/roo-ui/components';

import usePrependFlightInclusion from '@/v2/components/pages/PackageViewV2/hooks/usePrependFlightInclusion';
import PackageDetails from '@/v2/components/ui/PackageDetails';
import { PackageInclusions } from '@/v2/components/ui/PackageInclusions';
import {
  convertedHotelOfferInclusion,
  convertLeadInOfferInclusion,
} from '@/v2/utils/inclusions';

export type InclusionsProps = {
  propertyContent: UI.Property;
  procuredOffer?: UI.ProcuredOffer;
  offer: UI.RoomOptionOffer;
};
const Inclusions = ({
  offer,
  procuredOffer,
  propertyContent,
}: InclusionsProps) => {
  const { leadInOffer, hotelOffer } = offer;

  const baseInclusions =
    leadInOffer?.inclusions?.map(convertLeadInOfferInclusion) ??
    hotelOffer?.inclusions?.map(convertedHotelOfferInclusion);
  const inclusions = usePrependFlightInclusion(baseInclusions);

  return inclusions && inclusions?.length > 0 ? (
    <Flex
      data-testid="INCLUSIONS"
      alignItems="flex-start"
      flexDirection="column"
      gap="2"
    >
      <PackageInclusions numberToShow={4} inclusions={inclusions} />
      <PackageDetails
        propertyContent={propertyContent}
        procuredOffer={procuredOffer}
        leadInOffer={leadInOffer}
        inclusions={inclusions}
      />
    </Flex>
  ) : null;
};

export default Inclusions;
